/** Regional aggregate / cluster circles */
export const BID_MAP_ACCENT = '#2563eb';
export const BID_MAP_STROKE = '#1d4ed8';

/** Default bid pin when status unknown — aligns with status-tag `info` */
export const BID_MAP_STATUS_DEFAULT_PIN_FILL = '#3B82F6';

/** Field polygons — same as FieldManager VT styling */
export const BID_FIELD_POLYGON_FILL = 'rgba(156, 195, 26, 1)';
export const BID_FIELD_POLYGON_STROKE = '#ffffff';
